/**
 * RootReducer
 *
 * Ponto de junção de todos os reducers da aplicação.
 */

// third party
import { combineReducers } from 'redux'
// application reducers
import address from './address/AddressReducer'
import app from './app/AppReducer'
import auth from './auth/AuthReducer'
import context from './context/ContextReducer'
import country from './country/CountryReducer'
import dependent from './dependent/DependentReducer'
import exam from './exam/ExamReducer'
import quiz from './quiz/QuizReducer'
import patient from './patient/PatientReducer'
import pay from './pay/PayReducer'
import schedule from './schedule/ScheduleReducer'
import suportMessage from './suportMessage/SuportMessageReducer'
import prescriptionRenewal from './prescriptionRenewal/PrescriptionRenewalReducer'

const RootReducer = combineReducers({
  address,
  app,
  auth,
  context,
  country,
  dependent,
  exam,
  pay,
  quiz,
  patient,
  schedule,
  suportMessage,
  prescriptionRenewal,
})

export default RootReducer
